// extracted by mini-css-extract-plugin
export default {"loading":"BlockWithLoading_loading__hpCe3","loadingWithBackground":"BlockWithLoading_loadingWithBackground__iA0vi"};